module.exports = __webpack_public_path__ + "img/fineness-2@2x.7ea0733.webp";